/**
 * Timezone utilities for profile management
 */

// Get comprehensive list of timezones with user-friendly labels
export const getTimezoneList = () => {
  const timezones = [
    // UTC
    {
      value: "UTC",
      label: "UTC (Coordinated Universal Time)",
      offset: "+00:00",
      region: "UTC",
    },

    // Americas
    {
      value: "America/New_York",
      label: "New York (Eastern Time)",
      offset: "-05:00/-04:00",
      region: "Americas",
    },
    {
      value: "America/Chicago",
      label: "Chicago (Central Time)",
      offset: "-06:00/-05:00",
      region: "Americas",
    },
    {
      value: "America/Denver",
      label: "Denver (Mountain Time)",
      offset: "-07:00/-06:00",
      region: "Americas",
    },
    {
      value: "America/Los_Angeles",
      label: "Los Angeles (Pacific Time)",
      offset: "-08:00/-07:00",
      region: "Americas",
    },
    {
      value: "America/Anchorage",
      label: "Anchorage (Alaska Time)",
      offset: "-09:00/-08:00",
      region: "Americas",
    },
    {
      value: "Pacific/Honolulu",
      label: "Honolulu (Hawaii Time)",
      offset: "-10:00",
      region: "Americas",
    },
    {
      value: "America/Toronto",
      label: "Toronto (Eastern Time)",
      offset: "-05:00/-04:00",
      region: "Americas",
    },
    {
      value: "America/Vancouver",
      label: "Vancouver (Pacific Time)",
      offset: "-08:00/-07:00",
      region: "Americas",
    },
    {
      value: "America/Mexico_City",
      label: "Mexico City (Central Time)",
      offset: "-06:00/-05:00",
      region: "Americas",
    },
    {
      value: "America/Sao_Paulo",
      label: "São Paulo (Brasília Time)",
      offset: "-03:00/-02:00",
      region: "Americas",
    },
    {
      value: "America/Argentina/Buenos_Aires",
      label: "Buenos Aires (Argentina Time)",
      offset: "-03:00",
      region: "Americas",
    },
    {
      value: "America/Lima",
      label: "Lima (Peru Time)",
      offset: "-05:00",
      region: "Americas",
    },
    {
      value: "America/Bogota",
      label: "Bogotá (Colombia Time)",
      offset: "-05:00",
      region: "Americas",
    },
    {
      value: "America/Caracas",
      label: "Caracas (Venezuela Time)",
      offset: "-04:00",
      region: "Americas",
    },

    // Europe
    {
      value: "Europe/London",
      label: "London (Greenwich Mean Time)",
      offset: "+00:00/+01:00",
      region: "Europe",
    },
    {
      value: "Europe/Paris",
      label: "Paris (Central European Time)",
      offset: "+01:00/+02:00",
      region: "Europe",
    },
    {
      value: "Europe/Berlin",
      label: "Berlin (Central European Time)",
      offset: "+01:00/+02:00",
      region: "Europe",
    },
    {
      value: "Europe/Rome",
      label: "Rome (Central European Time)",
      offset: "+01:00/+02:00",
      region: "Europe",
    },
    {
      value: "Europe/Madrid",
      label: "Madrid (Central European Time)",
      offset: "+01:00/+02:00",
      region: "Europe",
    },
    {
      value: "Europe/Amsterdam",
      label: "Amsterdam (Central European Time)",
      offset: "+01:00/+02:00",
      region: "Europe",
    },
    {
      value: "Europe/Brussels",
      label: "Brussels (Central European Time)",
      offset: "+01:00/+02:00",
      region: "Europe",
    },
    {
      value: "Europe/Vienna",
      label: "Vienna (Central European Time)",
      offset: "+01:00/+02:00",
      region: "Europe",
    },
    {
      value: "Europe/Zurich",
      label: "Zurich (Central European Time)",
      offset: "+01:00/+02:00",
      region: "Europe",
    },
    {
      value: "Europe/Stockholm",
      label: "Stockholm (Central European Time)",
      offset: "+01:00/+02:00",
      region: "Europe",
    },
    {
      value: "Europe/Oslo",
      label: "Oslo (Central European Time)",
      offset: "+01:00/+02:00",
      region: "Europe",
    },
    {
      value: "Europe/Copenhagen",
      label: "Copenhagen (Central European Time)",
      offset: "+01:00/+02:00",
      region: "Europe",
    },
    {
      value: "Europe/Helsinki",
      label: "Helsinki (Eastern European Time)",
      offset: "+02:00/+03:00",
      region: "Europe",
    },
    {
      value: "Europe/Warsaw",
      label: "Warsaw (Central European Time)",
      offset: "+01:00/+02:00",
      region: "Europe",
    },
    {
      value: "Europe/Prague",
      label: "Prague (Central European Time)",
      offset: "+01:00/+02:00",
      region: "Europe",
    },
    {
      value: "Europe/Budapest",
      label: "Budapest (Central European Time)",
      offset: "+01:00/+02:00",
      region: "Europe",
    },
    {
      value: "Europe/Athens",
      label: "Athens (Eastern European Time)",
      offset: "+02:00/+03:00",
      region: "Europe",
    },
    {
      value: "Europe/Istanbul",
      label: "Istanbul (Turkey Time)",
      offset: "+03:00",
      region: "Europe",
    },
    {
      value: "Europe/Moscow",
      label: "Moscow (Moscow Time)",
      offset: "+03:00",
      region: "Europe",
    },
    {
      value: "Europe/Kiev",
      label: "Kiev (Eastern European Time)",
      offset: "+02:00/+03:00",
      region: "Europe",
    },

    // Asia
    {
      value: "Asia/Tokyo",
      label: "Tokyo (Japan Standard Time)",
      offset: "+09:00",
      region: "Asia",
    },
    {
      value: "Asia/Seoul",
      label: "Seoul (Korea Standard Time)",
      offset: "+09:00",
      region: "Asia",
    },
    {
      value: "Asia/Shanghai",
      label: "Shanghai (China Standard Time)",
      offset: "+08:00",
      region: "Asia",
    },
    {
      value: "Asia/Hong_Kong",
      label: "Hong Kong (Hong Kong Time)",
      offset: "+08:00",
      region: "Asia",
    },
    {
      value: "Asia/Singapore",
      label: "Singapore (Singapore Time)",
      offset: "+08:00",
      region: "Asia",
    },
    {
      value: "Asia/Bangkok",
      label: "Bangkok (Indochina Time)",
      offset: "+07:00",
      region: "Asia",
    },
    {
      value: "Asia/Jakarta",
      label: "Jakarta (Western Indonesia Time)",
      offset: "+07:00",
      region: "Asia",
    },
    {
      value: "Asia/Manila",
      label: "Manila (Philippines Time)",
      offset: "+08:00",
      region: "Asia",
    },
    {
      value: "Asia/Kuala_Lumpur",
      label: "Kuala Lumpur (Malaysia Time)",
      offset: "+08:00",
      region: "Asia",
    },
    {
      value: "Asia/Taipei",
      label: "Taipei (China Standard Time)",
      offset: "+08:00",
      region: "Asia",
    },
    {
      value: "Asia/Ho_Chi_Minh",
      label: "Ho Chi Minh City (Indochina Time)",
      offset: "+07:00",
      region: "Asia",
    },
    {
      value: "Asia/Kolkata",
      label: "Kolkata (India Standard Time)",
      offset: "+05:30",
      region: "Asia",
    },
    {
      value: "Asia/Mumbai",
      label: "Mumbai (India Standard Time)",
      offset: "+05:30",
      region: "Asia",
    },
    {
      value: "Asia/Delhi",
      label: "Delhi (India Standard Time)",
      offset: "+05:30",
      region: "Asia",
    },
    {
      value: "Asia/Dhaka",
      label: "Dhaka (Bangladesh Time)",
      offset: "+06:00",
      region: "Asia",
    },
    {
      value: "Asia/Karachi",
      label: "Karachi (Pakistan Time)",
      offset: "+05:00",
      region: "Asia",
    },
    {
      value: "Asia/Dubai",
      label: "Dubai (Gulf Standard Time)",
      offset: "+04:00",
      region: "Asia",
    },
    {
      value: "Asia/Riyadh",
      label: "Riyadh (Arabia Standard Time)",
      offset: "+03:00",
      region: "Asia",
    },
    {
      value: "Asia/Tehran",
      label: "Tehran (Iran Time)",
      offset: "+03:30/+04:30",
      region: "Asia",
    },
    {
      value: "Asia/Jerusalem",
      label: "Jerusalem (Israel Time)",
      offset: "+02:00/+03:00",
      region: "Asia",
    },
    {
      value: "Asia/Beirut",
      label: "Beirut (Eastern European Time)",
      offset: "+02:00/+03:00",
      region: "Asia",
    },
    {
      value: "Asia/Yerevan",
      label: "Yerevan (Armenia Time)",
      offset: "+04:00",
      region: "Asia",
    },
    {
      value: "Asia/Baku",
      label: "Baku (Azerbaijan Time)",
      offset: "+04:00",
      region: "Asia",
    },
    {
      value: "Asia/Tashkent",
      label: "Tashkent (Uzbekistan Time)",
      offset: "+05:00",
      region: "Asia",
    },
    {
      value: "Asia/Almaty",
      label: "Almaty (Almaty Time)",
      offset: "+06:00",
      region: "Asia",
    },

    // Africa
    {
      value: "Africa/Cairo",
      label: "Cairo (Eastern European Time)",
      offset: "+02:00",
      region: "Africa",
    },
    {
      value: "Africa/Lagos",
      label: "Lagos (West Africa Time)",
      offset: "+01:00",
      region: "Africa",
    },
    {
      value: "Africa/Johannesburg",
      label: "Johannesburg (South Africa Time)",
      offset: "+02:00",
      region: "Africa",
    },
    {
      value: "Africa/Nairobi",
      label: "Nairobi (East Africa Time)",
      offset: "+03:00",
      region: "Africa",
    },
    {
      value: "Africa/Casablanca",
      label: "Casablanca (Western European Time)",
      offset: "+00:00/+01:00",
      region: "Africa",
    },
    {
      value: "Africa/Algiers",
      label: "Algiers (Central European Time)",
      offset: "+01:00",
      region: "Africa",
    },
    {
      value: "Africa/Tunis",
      label: "Tunis (Central European Time)",
      offset: "+01:00",
      region: "Africa",
    },
    {
      value: "Africa/Addis_Ababa",
      label: "Addis Ababa (East Africa Time)",
      offset: "+03:00",
      region: "Africa",
    },
    {
      value: "Africa/Dar_es_Salaam",
      label: "Dar es Salaam (East Africa Time)",
      offset: "+03:00",
      region: "Africa",
    },
    {
      value: "Africa/Khartoum",
      label: "Khartoum (Central Africa Time)",
      offset: "+02:00",
      region: "Africa",
    },

    // Australia & Oceania
    {
      value: "Australia/Sydney",
      label: "Sydney (Australian Eastern Time)",
      offset: "+10:00/+11:00",
      region: "Australia & Oceania",
    },
    {
      value: "Australia/Melbourne",
      label: "Melbourne (Australian Eastern Time)",
      offset: "+10:00/+11:00",
      region: "Australia & Oceania",
    },
    {
      value: "Australia/Brisbane",
      label: "Brisbane (Australian Eastern Time)",
      offset: "+10:00",
      region: "Australia & Oceania",
    },
    {
      value: "Australia/Perth",
      label: "Perth (Australian Western Time)",
      offset: "+08:00",
      region: "Australia & Oceania",
    },
    {
      value: "Australia/Adelaide",
      label: "Adelaide (Australian Central Time)",
      offset: "+09:30/+10:30",
      region: "Australia & Oceania",
    },
    {
      value: "Australia/Darwin",
      label: "Darwin (Australian Central Time)",
      offset: "+09:30",
      region: "Australia & Oceania",
    },
    {
      value: "Pacific/Auckland",
      label: "Auckland (New Zealand Time)",
      offset: "+12:00/+13:00",
      region: "Australia & Oceania",
    },
    {
      value: "Pacific/Fiji",
      label: "Fiji (Fiji Time)",
      offset: "+12:00/+13:00",
      region: "Australia & Oceania",
    },
    {
      value: "Pacific/Guam",
      label: "Guam (Chamorro Time)",
      offset: "+10:00",
      region: "Australia & Oceania",
    },
    {
      value: "Pacific/Tahiti",
      label: "Tahiti (Tahiti Time)",
      offset: "-10:00",
      region: "Australia & Oceania",
    },
  ];

  // Sort by region, then by label
  return timezones.sort((a, b) => {
    if (a.region !== b.region) {
      // Custom region order
      const regionOrder = [
        "UTC",
        "Americas",
        "Europe",
        "Asia",
        "Africa",
        "Australia & Oceania",
      ];
      return regionOrder.indexOf(a.region) - regionOrder.indexOf(b.region);
    }
    return a.label.localeCompare(b.label);
  });
};

// Get browser's timezone
export const getBrowserTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (error) {
    console.warn("Unable to detect browser timezone:", error);
    return "UTC";
  }
};

// Get timezone display name
export const getTimezoneDisplayName = (timezone) => {
  try {
    const now = new Date();
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: timezone,
      timeZoneName: "long",
    });

    const parts = formatter.formatToParts(now);
    const timeZoneName = parts.find(
      (part) => part.type === "timeZoneName"
    )?.value;

    return timeZoneName || timezone;
  } catch (error) {
    return timezone;
  }
};

// Get current offset for a timezone
export const getTimezoneOffset = (timezone) => {
  try {
    const now = new Date();
    const utc = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
    const targetTime = new Date(
      utc.toLocaleString("en-US", { timeZone: timezone })
    );
    const offset = (targetTime.getTime() - utc.getTime()) / (1000 * 60 * 60);

    const sign = offset >= 0 ? "+" : "-";
    const hours = Math.floor(Math.abs(offset));
    const minutes = Math.round((Math.abs(offset) - hours) * 60);

    return `${sign}${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
  } catch (error) {
    return "+00:00";
  }
};

// Format time in specific timezone
export const formatTimeInTimezone = (date, timezone, options = {}) => {
  try {
    return new Intl.DateTimeFormat("en-US", {
      timeZone: timezone,
      ...options,
    }).format(date);
  } catch (error) {
    return date.toLocaleString();
  }
};

// Check if timezone supports DST
export const supportsDST = (timezone) => {
  try {
    const jan = new Date(2023, 0, 1);
    const jul = new Date(2023, 6, 1);

    // Get offsets for January and July to detect DST
    const janFormatter = new Intl.DateTimeFormat('en', {
      timeZone: timezone,
      timeZoneName: 'longOffset'
    });
    const julFormatter = new Intl.DateTimeFormat('en', {
      timeZone: timezone,
      timeZoneName: 'longOffset'
    });

    const janOffset = janFormatter.formatToParts(jan).find(part => part.type === 'timeZoneName')?.value;
    const julOffset = julFormatter.formatToParts(jul).find(part => part.type === 'timeZoneName')?.value;

    return janOffset !== julOffset;
  } catch (error) {
    return false;
  }
};

// Group timezones by region
export const getTimezonesByRegion = () => {
  const timezones = getTimezoneList();
  const grouped = {};

  timezones.forEach((tz) => {
    if (!grouped[tz.region]) {
      grouped[tz.region] = [];
    }
    grouped[tz.region].push(tz);
  });

  return grouped;
};

// Search timezones
export const searchTimezones = (query) => {
  if (!query || query.length < 2) {
    return getTimezoneList();
  }

  const searchTerm = query.toLowerCase();
  const timezones = getTimezoneList();

  return timezones.filter(
    (tz) =>
      tz.label.toLowerCase().includes(searchTerm) ||
      tz.value.toLowerCase().includes(searchTerm) ||
      tz.region.toLowerCase().includes(searchTerm)
  );
};

// Get popular timezones (most commonly used)
export const getPopularTimezones = () => {
  const popular = [
    "UTC",
    "America/New_York",
    "America/Los_Angeles",
    "America/Chicago",
    "Europe/London",
    "Europe/Paris",
    "Asia/Tokyo",
    "Asia/Shanghai",
    "Australia/Sydney",
    "America/Toronto",
  ];

  const allTimezones = getTimezoneList();
  return popular
    .map((value) => allTimezones.find((tz) => tz.value === value))
    .filter(Boolean);
};

// Legacy function for backward compatibility with api.js
// This function is used by the API client to include timezone headers
export const getUserTimezone = () => {
  return getBrowserTimezone();
};

// Get current date and time formatted for datetime-local input
export const getCurrentDateTimeForInput = () => {
  try {
    const now = new Date();
    
    // Check if date is valid
    if (isNaN(now.getTime())) {
      console.error('getCurrentDateTimeForInput: Invalid current date');
      return '';
    }
    
    // Adjust for timezone offset to get local time
    const localTime = new Date(now.getTime() - (now.getTimezoneOffset() * 60000));
    return localTime.toISOString().slice(0, 16); // Format: YYYY-MM-DDTHH:MM
  } catch (error) {
    console.error('getCurrentDateTimeForInput: Error getting current datetime:', error);
    return '';
  }
};

// Convert UTC datetime string to local datetime string for input fields
export const fromUTCForInput = (utcString) => {
  if (!utcString) {
    console.warn('fromUTCForInput: Empty UTC string provided');
    return '';
  }
  
  if (!validateDateTimeString(utcString)) {
    console.error('fromUTCForInput: Invalid UTC datetime string:', utcString);
    return '';
  }
  
  try {
    const utcDate = new Date(utcString);
    
    // Check if date is valid
    if (isNaN(utcDate.getTime())) {
      console.error('fromUTCForInput: Invalid date object created from:', utcString);
      return '';
    }
    
    // Adjust for timezone offset to get local time
    const localTime = new Date(utcDate.getTime() - (utcDate.getTimezoneOffset() * 60000));
    const result = localTime.toISOString().slice(0, 16); // Format: YYYY-MM-DDTHH:MM
    
    return result;
  } catch (error) {
    console.error('fromUTCForInput: Error converting UTC to local time:', error);
    return '';
  }
};

// Convert local datetime string to UTC for API
export const toUTCForAPI = (localDateTimeString) => {
  if (!localDateTimeString) {
    console.warn('toUTCForAPI: Empty datetime string provided');
    return '';
  }
  
  if (!validateDateTimeString(localDateTimeString)) {
    console.error('toUTCForAPI: Invalid datetime string:', localDateTimeString);
    return '';
  }
  
  try {
    // Create a date object from the local datetime string
    const localDate = new Date(localDateTimeString);
    
    // Check if date is valid
    if (isNaN(localDate.getTime())) {
      console.error('toUTCForAPI: Invalid date object created from:', localDateTimeString);
      return '';
    }
    
    // Return as ISO string (which is in UTC)
    const isoString = localDate.toISOString();
    
    return isoString;
  } catch (error) {
    console.error('toUTCForAPI: Error converting local time to UTC:', error);
    return '';
  }
};

// Format datetime for display with timezone awareness
export const formatDateTimeForDisplay = (dateTimeString, options = {}) => {
  if (!dateTimeString) {
    console.warn('formatDateTimeForDisplay: Empty datetime string provided');
    return '';
  }
  
  if (!validateDateTimeString(dateTimeString)) {
    console.error('formatDateTimeForDisplay: Invalid datetime string:', dateTimeString);
    return dateTimeString;
  }
  
  try {
    const date = new Date(dateTimeString);
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      console.error('formatDateTimeForDisplay: Invalid date object created from:', dateTimeString);
      return dateTimeString;
    }
    
    const defaultOptions = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    };
    
    const formatOptions = { ...defaultOptions, ...options };
    return date.toLocaleString('en-US', formatOptions);
  } catch (error) {
    console.error('formatDateTimeForDisplay: Error formatting datetime:', error);
    return dateTimeString;
  }
};

// Get relative time string (e.g., "2 hours ago", "just now")
export const getRelativeTime = (dateTimeString) => {
  if (!dateTimeString) return '';
  
  try {
    const date = new Date(dateTimeString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);
    
    if (diffInSeconds < 60) {
      return 'just now';
    } else if (diffInSeconds < 3600) {
      const minutes = Math.floor(diffInSeconds / 60);
      return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
    } else if (diffInSeconds < 86400) {
      const hours = Math.floor(diffInSeconds / 3600);
      return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
    } else if (diffInSeconds < 604800) {
      const days = Math.floor(diffInSeconds / 86400);
      return `${days} day${days !== 1 ? 's' : ''} ago`;
    } else if (diffInSeconds < 2592000) {
      const weeks = Math.floor(diffInSeconds / 604800);
      return `${weeks} week${weeks !== 1 ? 's' : ''} ago`;
    } else if (diffInSeconds < 31536000) {
      const months = Math.floor(diffInSeconds / 2592000);
      return `${months} month${months !== 1 ? 's' : ''} ago`;
    } else {
      const years = Math.floor(diffInSeconds / 31536000);
      return `${years} year${years !== 1 ? 's' : ''} ago`;
    }
  } catch (error) {
    console.warn('Error calculating relative time:', error);
    return '';
  }
};

// Check if a date is today
export const isToday = (dateTimeString) => {
  if (!dateTimeString) return false;
  
  try {
    const date = new Date(dateTimeString);
    const today = new Date();
    
    return date.getDate() === today.getDate() &&
           date.getMonth() === today.getMonth() &&
           date.getFullYear() === today.getFullYear();
  } catch (error) {
    console.warn('Error checking if date is today:', error);
    return false;
  }
};

/**
 * Get timezone abbreviation (e.g., "EST", "PST", "UTC")
 * 
 * @param {string} timezone - IANA timezone name (optional, uses browser tz if not provided)
 * @returns {string} Timezone abbreviation
 */
export const getTimezoneAbbreviation = (timezone = null) => {
  try {
    const tz = timezone || getBrowserTimezone();
    const now = new Date();
    
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      timeZoneName: 'short'
    });
    
    const parts = formatter.formatToParts(now);
    const abbreviation = parts.find(part => part.type === 'timeZoneName')?.value;
    
    return abbreviation || tz;
  } catch (error) {
    console.warn('Error getting timezone abbreviation:', error);
    return 'UTC';
  }
};

/**
 * Format timezone offset for display (e.g., "UTC-5", "UTC+5:30")
 * 
 * @param {string} timezone - IANA timezone name (optional, uses browser tz if not provided)
 * @returns {string} Formatted offset
 */
export const formatTimezoneOffset = (timezone = null) => {
  try {
    const tz = timezone || getBrowserTimezone();
    const offset = getTimezoneOffset(tz);
    
    // Parse the offset (format: +HH:MM or -HH:MM)
    const match = offset.match(/([+-])(\d{2}):(\d{2})/);
    if (!match) return 'UTC';
    
    const [, sign, hours, minutes] = match;
    const hoursNum = parseInt(hours, 10);
    const minutesNum = parseInt(minutes, 10);
    
    // Special case for UTC (offset is +00:00)
    if (hoursNum === 0 && minutesNum === 0) {
      return 'UTC';
    }
    
    // Format as UTC±H or UTC±H:MM for half-hour offsets
    if (minutesNum === 0) {
      return `UTC${sign}${hoursNum}`;
    } else {
      return `UTC${sign}${hoursNum}:${minutes}`;
    }
  } catch (error) {
    console.warn('Error formatting timezone offset:', error);
    return 'UTC';
  }
};

/**
 * Validate that a datetime string is properly formatted
 * 
 * @param {string} dateTimeString - DateTime string to validate
 * @returns {boolean} True if valid
 */
export const validateDateTimeString = (dateTimeString) => {
  if (!dateTimeString || typeof dateTimeString !== 'string') {
    return false;
  }
  
  try {
    const date = new Date(dateTimeString);
    
    // Check if the date is valid (not NaN)
    if (isNaN(date.getTime())) {
      return false;
    }
    
    // Check if the date is within a reasonable range
    // (between year 1900 and 2100)
    const year = date.getFullYear();
    if (year < 1900 || year > 2100) {
      return false;
    }
    
    return true;
  } catch (error) {
    return false;
  }
};

/**
 * Safely convert local datetime to UTC with error handling
 * 
 * @param {string} localDateTimeString - Local datetime string
 * @returns {string|null} UTC ISO string or null on error
 */
export const safeToUTCForAPI = (localDateTimeString) => {
  if (!localDateTimeString) {
    console.warn('safeToUTCForAPI: Empty datetime string provided');
    return null;
  }
  
  if (!validateDateTimeString(localDateTimeString)) {
    console.error('safeToUTCForAPI: Invalid datetime string:', localDateTimeString);
    return null;
  }
  
  try {
    const localDate = new Date(localDateTimeString);
    const isoString = localDate.toISOString();
    
    // Validate the output
    if (!isoString || !validateDateTimeString(isoString)) {
      console.error('safeToUTCForAPI: Failed to convert to valid ISO string');
      return null;
    }
    
    return isoString;
  } catch (error) {
    console.error('safeToUTCForAPI: Error converting local time to UTC:', error);
    return null;
  }
};